import { StructureTypeCode } from "@/lib/interfaces and Enums/ENUMStructureTypeCode";
import { TableHeaderField } from "@/lib/interfaces and Enums/ENUMTableHeaders";
import React from "react";

const DealtPriceHeader = (params: any) => {
  if (params.fullTradeData.structureType) {
  }
  const isSynRepo =
    params.fullTradeData.structureType == StructureTypeCode.SYNREPO ||
    params.fullTradeData.structureType == StructureTypeCode.SYNREVREP
      ? true
      : false;

  return (
    <div data-testid="dealtPriceHeader">
      {isSynRepo
        ? TableHeaderField.dealtRepoRate
        : TableHeaderField.feeAdjustedQuote}
    </div>
  );
};

export default DealtPriceHeader;
